import { useContextFallback } from '@prenuvo/halo-foundation';

import { NavMenuContext } from './nav-menu.context';

export const useNavMenu = () => useContextFallback(NavMenuContext);
